import type { TacticBuild } from '../Page/TacticBuild';

/**
 * 전투기록 창·공략 [룬 정보]의 [내 룬으로 맞추기] → 룬 옵티마이저 [룬피팅] 탭으로 공덱 룬작을 넘긴다 (사용자 2026-10-27).
 *
 * 탭을 바꾸면 룬 옵티마이저 화면이 새로 뜨므로 이벤트만으로는 받을 자리가 없다 — 여기 맡겨 두고,
 * 룬 옵티마이저가 뜰 때(이미 떠 있으면 이벤트로) 꺼내 간다(`takeRuneFit`). utils/simHandoff 와 같은 짜임.
 */
export interface RuneFitSource {
    /** 어디서 왔나 — 화면 머리 한 줄 (예: '전투기록 공덱', '공략 「…」') */
    label: string;
    /** 공덱 셋 — 몹 번호를 알면 unitMasterId(전투기록), 모르면 이름·속성(공략)으로 서버가 찾는다 */
    mobs: Array<{ name: string; attribute: string; unitMasterId?: number | null }>;
    /** 칸마다 원본 룬작 — 세트·능력치·아티 부옵이 맞출 목표가 된다. 없는 칸은 몹 유형 가중만 */
    builds: Array<TacticBuild | null | undefined>;
}

let pending: RuneFitSource | null = null;

/** 맡겨 두고 룬 옵티마이저 탭으로 간다(PageContainer 가 `swpvpdb:open-rune-fit` 을 듣는다) */
export function openRuneFit(s: RuneFitSource): void {
    pending = s;
    window.dispatchEvent(new CustomEvent('swpvpdb:open-rune-fit'));
}

export function takeRuneFit(): RuneFitSource | null {
    const s = pending;
    pending = null;
    return s;
}
